import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import { type MessagesComparisonTableStore } from 'pages/analytics/pages/messages/store/messagesAnalyticsPageStore'
import { getColumns } from './getColumns'

interface IMessagesComparisonTableProps {
  store: MessagesComparisonTableStore
}

export const MessagesComparisonTable = observer(({ store }: IMessagesComparisonTableProps) => {
  const { tableStore, comparisonRows, breakdownFilterType } = store

  const columns = useMemo(() => getColumns(breakdownFilterType), [breakdownFilterType])

  return (
    <Table
      ariaLabel={'MessagesComparisonTable'}
      store={tableStore}
      columns={columns}
      rows={comparisonRows}
      hidePagination={true}
      emptyStateProps={{
        text: 'No comparison data found',
        noIcon: true,
      }}
      scrollbarProps={{
        autoHeight: true,
        height: 'auto',
        autoHeightMax: 600,
      }}
    />
  )
})
